import project from './project';

const config = {
  skillup: [
    {
      label: 'Shortest Training',
      value: 'shortest',
    },
    {
      label: 'Highest Earning',
      value: 'salary',
    },
    {
      label: 'A-Z',
      value: 'title',
    },
  ],
  wherewego: [
    {
      label: 'Best Outlook',
      value: 'brightOutlook',
    },
    { label: 'Shortest Training', value: 'jobZone' },
    {
      label: 'Highest earning',
      value: 'salary',
    },
  ],
};

const careerSortOptions = config[project];

export default careerSortOptions;
